// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1QqqZ","title":"Images90_title__TkX97","images":"Images90_images__1SGlh"};